// Generado automáticamente por scripts/build-ui-catalog.mjs. No editar.
export const organizeUiCatalog = [
  ": mayor a menor",
  "¿Aplicar estos puntos de corte?",
  "¿Cerrar sin guardar el borrador?",
  "¿Completar el perfil con IA?",
  "¿Confirmás la eliminación?",
  "¿Deseás que la IA busque ahora una foto pública y prepare un resumen profesional y académico? Solo se enviarán nombre, institución, país y categoría a OpenAI.",
  "¿Desenlazar WhatsApp?",
  "¿Eliminar esta sesión?",
  "¿Enviar la comunicación?",
  "¿Enviar la notificación push?",
  "¿Mover este mensaje a la papelera?",
  "¿Necesitás ayuda?",
  "¿Olvidaste tu contraseña?",
  ". Cada árbitro los puntuará de 0 a 10; el promedio ponderado será el puntaje general.",
  ". Las funciones de este evento usan exclusivamente esta clave; la variable OPENAI_API_KEY del servidor no se utiliza como reemplazo.",
  ". Se conserva el expediente y queda fuera de evaluación.",
  "· asociados:",
  "· con push habilitado:",
  "· Ctrl/Cmd para selección múltiple",
  "· IA deshabilitada",
  "· Inactiva",
  "· Mobile",
  "· Modelos por función",
  "· Período:",
  "· Protegida",
  "· Rechazada por",
  "· última señal:",
  "· usá auriculares",
  "(inactivo)",
  "(Sin asunto)",
  "(Sin remitente)",
  ") más 5 minutos, desde que presionás Grabar.",
  "@virtualmedica.com",
  "/4 definidas",
  "• Lista",
  "← Cambiar email",
  "← Volver al ingreso",
  "+ Agregar",
  "+ Agregar firmante",
  "+ Agregar ítem",
  "+ Agregar participación",
  "+ Agregar subevento",
  "<p>Descripción, productos, enlaces y datos de contacto…</p>",
  "⌘ K",
  "○ Dispositivo anónimo",
  "○ Sin transmisión",
  "● Captura de Video Meeting en el servidor · Fin automático:",
  "● Conectado",
  "● En vivo",
  "● Escuchar traducción en vivo",
  "● Grabando · Restan",
  "● Grabar",
  "● Persona identificada",
  "✓ En mi agenda",
  "✓ Respuesta correcta",
  "✦ Perfil enriquecido con IA",
  "0 presentes",
  "0 significa sin límite.",
  "A workspace to coordinate the scientific program, speakers and operations. From the first invitation to the last agenda change.",
  "A-007",
  "Abre el acceso a este evento. Cada usuario ingresa con su cuenta y sus permisos habituales.",
  "Abriendo mensaje…",
  "Abrir acceso personalizado",
  "Abrir chat de WhatsApp",
  "Abrir chat grupal",
  "Abrir enlace de invitación ↗",
  "Abrir enlace privado",
  "Abrir escucha móvil",
  "Abrir menú",
  "Abrir página de origen ↗",
  "Abrir programa interactivo",
  "Abrir sala en otra pestaña",
  "Abrir sala Video Meeting ↗",
  "abstract",
  "Abstract",
  "abstract-status",
  "abstracts",
  "Abstracts",
  "Abstracts and results",
  "Abstracts e resultados",
  "Abstracts lo mostrará en un modal y generará automáticamente su versión PDF descargable.",
  "Abstracts y resultados",
  "Abstracts:",
  "accepted",
  "Acceso",
  "Acceso a todos sus eventos",
  "Acceso a traducción simultánea",
  "Acceso activo",
  "Acceso alternativo",
  "Acceso completo",
  "Acceso directo de Organize",
  "Acceso en vivo a las sesiones",
  "Acceso personalizado",
  "Acceso por WhatsApp",
  "acceso seguro",
  "Accesos del evento",
  "Acción: estado de Abstracts",
  "Acción: estado de Organize",
  "Acciones",
  "Acciones de estado",
  "Aceptado",
  "Aceptados",
  "Acercar plano",
  "Acompanhe cada trabalho da recepção à avaliação e seleção. Um processo organizado para autores, avaliadores e comitês científicos.",
  "Acompañá cada trabajo desde su recepción hasta la evaluación y selección. Un proceso organizado para autores, árbitros y comités científicos.",
  "Acrescente revisão assistida, comentários e devolutivas dos trabalhos para complementar a avaliação científica do comitê.",
  "Activa",
  "Activar audio traducido",
  "activas",
  "active",
  "actividades",
  "Activo",
  "Activo en Organize",
  "Actualización en vivo",
  "Actualizar",
  "Actualizar consumo de OpenAI",
  "Actualizar contraseña",
  "Actualizar grupo",
  "Add assisted review, comments and feedback on scientific submissions to complement the committee’s assessment.",
  "Además del autor principal. 0 significa sin límite.",
  "Adjuntar archivos · máximo 15 MB",
  "Adjuntos",
  "admin",
  "Administrá los planos y la ubicación gráfica de los stands. Asigná balizas físicas a cada stand.",
  "Administrá los valores disponibles al crear sesiones y asignaciones.",
  "Administrá quién puede ingresar y qué módulos puede utilizar.",
  "Administración general",
  "Administrado por",
  "Administrador",
  "administradores",
  "Administrar bloques horarios",
  "Administrar comunicaciones",
  "Administrar días y bloques",
  "Admite HTML. La app muestra texto, listas, negritas, cursivas y enlaces.",
  "Agenda",
  "Agenda en foco",
  "Agenda en PDF",
  "Agenda y sesiones",
  "Agrega Chat antes de PDF en la app para los perfiles registrados del evento.",
  "Agregá el primer proceso para comenzar a organizar el cronograma operativo del congreso.",
  "Agregar",
  "Agregar baliza",
  "Agregar banner",
  "Agregar enlace",
  "Agregar participación",
  "Agregar persona",
  "Agregar planta",
  "Agregar stand de expositor",
  "Agregar subevento",
  "Agregar un árbitro por IA",
  "AI questions and planning",
  "AI-assisted paper review",
  "Ajustá el texto de todo el sitio y del portal de faculty para este evento.",
  "Ajustes",
  "Ajustes del evento",
  "Al guardar se asignará una sala a esta sesión.",
  "Alcance",
  "Alcance del faculty",
  "Alejar plano",
  "all",
  "All",
  "Ambos",
  "Análisis operativo",
  "Análisis y sistema",
  "Anónimo",
  "Anterior",
  "Anteriores",
  "Aparece en la app; pueden publicarse varios eventos",
  "Apariciones del main sponsor",
  "Apariencia",
  "Apariencia de Meeting Organize",
  "Apellido *",
  "Apertura de recepción de trabajos",
  "API key de",
  "Aplicación",
  "Aplicaciones para casos especiales",
  "Aplicar a",
  "Aplicar selección",
  "apple",
  "Apple / Android",
  "aprobado",
  "arbitraje",
  "Arbitraje y selección",
  "Arbitrajes",
  "Arbitrajes realizados",
  "Árbitro ·",
  "Árbitro de trabajos científicos",
  "Árbitros",
  "Árbitros humanos por trabajo",
  "Árbitros identificados",
  "Archivado",
  "Archivo adjunto",
  "Archivo de audio",
  "Archivo de WhatsApp",
  "Archivo original",
  "Archivos",
  "Archivos PDF: OpenAI u OpenRouter. Otros documentos: OpenAI. DeepSeek todavía no tiene integrada la lectura de archivos.",
  "Área *",
  "Áreas del programa científico",
  "Armar la agenda",
  "Arrastrá cada stand; usá el punto inferior derecho para cambiar su tamaño.",
  "Arrastrá para marcar el área completa o mové cada esquina para ajustar rotación y perspectiva.",
  "Arrastrá sobre el mapa",
  "Artificial intelligence",
  "asc",
  "Asigná cuentas que tengan el rol predefinido Expositor. Una cuenta puede pertenecer a una sola empresa.",
  "Asigná personas, roles, temas y tiempos de intervención.",
  "Asigná únicamente trabajos aprobados. Cada mesa acepta trabajos de su mismo subevento y formato —oral o póster—.",
  "Asignación",
  "Asignación automática de árbitros",
  "Asignación de mesas",
  "Asignación por temática, puntajes, seguimiento de evaluaciones y comunicaciones a los autores.",
  "Asignar",
  "Asignar / desasignar",
  "Asignar árbitros ahora",
  "Asignar trabajo",
  "Asistente",
  "ASISTENTE",
  "ASISTENTES EN VIVO",
  "Asistentes identificados",
  "Asistentes registrados",
  "Ask the assistant about the event and organize your participation with session recommendations and an agenda based on your interests.",
  "Asunto",
  "Asunto *",
  "Atención: tu agenda tiene",
  "Audiencia",
  "Audiencia sugerida:",
  "audio",
  "Audio detectado",
  "Audio preparado. Esperando que Organize inicie la transmisión…",
  "Audio y actividades educativas",
  "Audio y traducción",
  "Auspicia",
  "Auspiciada por",
  "Auspiciante",
  "Auspiciante no disponible — reemplazar o quitar",
  "Auspiciantes del evento",
  "Autenticación",
  "authenticated",
  "Autores",
  "Autores de trabajos",
  "Autores responsables de trabajos",
  "Avaliação e seleção",
  "average",
  "Baixe o meetingPlanner",
  "Baliza",
  "Balizas de esta sala",
  "Balizas de los stands",
  "Bandeja de correo del evento",
  "Bandeja de WhatsApp",
  "Banner",
  "Banner anterior",
  "Banner del evento",
  "Banner general del evento",
  "Banner para comunicaciones",
  "Banner siguiente",
  "Bases, formatos, criterios, fechas y condiciones…",
  "between",
  "BH",
  "Bienvenido al llamado científico…",
  "blocked",
  "Bloque horario",
  "Bloqueado",
  "Bloques horarios",
  "Bloques horarios *",
  "Borrador",
  "Borrador educativo · Revisá las preguntas y respuestas antes de utilizarlas. No se publican automáticamente en los quizzes en vivo.",
  "Borrar la contraseña SMTP guardada",
  "both",
  "Bring the administration of practical training activities into one place.",
  "Build the schedule",
  "Buscando",
  "Buscar asistente en el stand",
  "Buscar en el evento",
  "Buscar en todo el evento (⌘/Ctrl + K)",
  "Buscar faculty",
  "Buscar nombre o email…",
  "Buscar por ID, título o responsable",
  "Buscar por nombre o apellido",
  "Buscar por nombre, email o institución",
  "Buscar sesión, tema, faculty, función o institución",
  "Buscar sesión, temática o disertante",
  "Buscar sesiones",
  "Buscar trabajos",
  "Cada subevento administra su propia etapa, invitaciones y disponibilidad de materiales.",
  "Call for Science",
  "Call4Science",
  "Cámara, micrófono y pantalla compartida habilitados",
  "Cambiar evento",
  "Cambios guardados correctamente",
  "Canal de ingreso",
  "Canales de envío",
  "Canales directos",
  "Cancelá o arrastrá el área",
  "Cancelada",
  "Cancelado",
  "Cancelar",
  "cancelled",
  "Cantidad máxima de orales",
  "Cantidad máxima de pósters",
  "Cantidad por canal",
  "Capacity and registration",
  "capped",
  "Captura y transmisión de la sesión",
  "Cargá, editá y enviá trabajos científicos desde un único espacio, claro y seguro.",
  "Cargando configuración…",
  "Cargando correos…",
  "Cargando detalle…",
  "Cargando el documento…",
  "Cargando plano…",
  "Cargando plataformas de IA...",
  "Cargando programa interactivo…",
  "Cargo",
  "Carpetas de correo",
  "Casilla del evento sin configurar",
  "Casilla remitente",
  "Caso clínico",
  "Catálogo de modelos",
  "Categoría",
  "CC",
  "CC:",
  "CCO",
  "Celular con WhatsApp *",
  "Centralizá la administración de las propuestas de capacitación práctica.",
  "Centralize a administração das propostas de capacitação prática.",
  "Centro de mensajes",
  "Cerrado",
  "Cerrar",
  "Cerrar asignación de mesas",
  "Cerrar aviso",
  "Cerrar bandeja",
  "Cerrar búsqueda",
  "Cerrar consumo de OpenAI",
  "Cerrar detalle",
  "Cerrar menú",
  "Cerrar sala",
  "Cerrar sesión",
  "Chamadas sob medida",
  "Chat grupal",
  "Cierre de recepción de trabajos",
  "Ciudad",
  "Ciudad a confirmar",
  "Claro",
  "Clasificación independiente de sus funciones. Se administra desde Ajustes → Tipos de Faculty.",
  "Clave configurada",
  "Clave de acceso",
  "Clave efectiva actual:",
  "Clave inicial *",
  "clinical_case",
  "CM 2027",
  "code",
  "Código de acceso",
  "Código de color",
  "Código de recuperación",
  "Código de stand",
  "Código de streaming",
  "Código interno",
  "Código QR para vincular WhatsApp",
  "Cola no anulable",
  "Color",
  "Color de fondo alternativo",
  "Color principal",
  "Comienzo de los arbitrajes",
  "Communicate and coordinate",
  "communication",
  "communications",
  "Communications and operations",
  "Como organizar um evento",
  "Cómo organizar un evento",
  "Compartí el acceso personalizado. El sistema lo redirige al enlace privado protegido por UUID.",
  "Compartí este enlace con los participantes. La UUID evita que puedan descubrir otros eventos modificando solamente el número.",
  "Compatible con temática y subevento",
  "completed",
  "Comprobando…",
  "Comunicación enviada",
  "Comunicación general",
  "Comunicación no enviada",
  "Comunicación protegida: INVITAR A GRUPO",
  "Comunicaciones",
  "Comunicaciones · Organize y Call4Science",
  "comunicaciones disponibles",
  "Comunicaciones en Idioma Principal del Evento",
  "Comunicaciones y operación",
  "Comunicações e operação",
  "Comunicar e coordenar",
  "Comunicar y coordinar",
  "Con cantidad 2 y 50 destinatarios se enviarán como máximo 2 emails y 2 WhatsApp a los destinos de prueba. Se conserva el contenido personalizado. Los push quedan suspendidos y las pruebas no marcan a los participantes como notificados.",
  "con email",
  "con error",
  "Concentración",
  "CONCURRENCIA",
  "Conectando a Jitsi",
  "Conectando con Real Time…",
  "Conectando con SQL Server…",
  "Conectar audio de Jitsi desde el servidor",
  "Conectar una sala",
  "CONF",
  "Conferencias, mesas y talleres",
  "Configurá balizas y ubicaciones para registrar visitas y consultar la presencia de participantes en espacios del evento.",
  "Configurá la corrección por IA",
  "Configurá las balizas físicas de cada stand. También se mantienen disponibles los teléfonos emisores de meetingPlanner.",
  "Configurá quién puede acceder al audio de traducción durante las sesiones.",
  "Configuración",
  "Configuración de comunicaciones guardada",
  "Configuración de subeventos",
  "Configuración del evento guardada",
  "Configurar IA para Organize",
  "Configure Balizas and locations to record visits and review participant presence across event spaces.",
  "Configure Balizas e localizações para registrar visitas e consultar a presença dos participantes nos espaços do evento.",
  "Confirmación",
  "Confirmaciones",
  "Confirmada",
  "Confirmado",
  "Confirmados",
  "Confirmar contraseña",
  "Confirmar envío de prueba",
  "Confirmar envío simultáneo",
  "Confirmar nueva clave",
  "confirmed",
  "congreso2027",
  "Connect your participation with the spaces you visit through location and Balizas, with your consent and on compatible devices.",
  "connecting",
  "Conservação e proteção",
  "Conservación y protección",
  "Consultá al asistente sobre el evento y organizá tu participación con recomendaciones de sesiones y una agenda según tus intereses.",
  "Consulta las credenciales ya almacenadas para este evento; no modifica la configuración.",
  "Consultado:",
  "Consultando dispositivos…",
  "Consultando…",
  "Consultar consumo de OpenAI",
  "Consultas e organização com IA",
  "Consultas y organización con IA",
  "Consulte o assistente sobre o evento e organize sua participação com recomendações de sessões e uma agenda conforme seus interesses.",
  "Consumo de OpenAI",
  "Contactarme por mi asistente",
  "Contenido",
  "Contenido del trabajo",
  "Contenido generado con IA a partir de información pública. Verificá los datos antes de publicarlos o utilizarlos.",
  "Contenido libre (HTML)",
  "Contraseña",
  "Contraseña *",
  "Contraseña de la sala (si corresponde)",
  "Contraseña SMTP",
  "Control de presencia al acceso",
  "Conversaciones",
  "Convirtiendo el PowerPoint a PDF. La primera visualización puede demorar unos segundos.",
  "Convocatorias a medida",
  "Coordene os espaços e as estações que fazem parte de cada oficina.",
  "Coordiná los espacios y las estaciones que forman parte de cada taller.",
  "Coordinate the spaces and stations that make up each workshop.",
  "Copiá el UUID, Major y Minor configurados en cada baliza física.",
  "Copiar acceso personalizado",
  "Copiar enlace privado",
  "Copiar UUID",
  "Correção de temas livres por IA",
  "Corrección de temas libres por IA",
  "Corrección por IA",
  "Corregir con IA",
  "Correos",
  "Corrigiendo con IA",
  "Corte oral",
  "Corte póster",
  "Costo estimado",
  "Costo local estimado",
  "Creá congresos y elegí cuál querés gestionar en el panel.",
  "Creá el primer evento desde la base de datos inicial.",
  "Creá las franjas horarias de esta jornada antes de ubicar sesiones.",
  "Creá las mesas desde Ajustes → Mesas científicas.",
  "Creá tu nueva contraseña",
  "Creá una nueva contraseña",
  "Crear clave",
  "Crear grupo",
  "Crear primer hito",
  "Crear registro",
  "Crear y configurar el evento",
  "Create and configure the event",
  "Credencial almacenada",
  "Credenciales guardadas",
  "Credenciales y modelos del evento, centralizados por proveedor.",
  "Criar e configurar o evento",
  "Criterio de clasificación o alcance",
  "Cualquiera",
  "Cuenta adicional de salida",
  "Cuenta configurada",
  "Cuenta de correo guardada",
  "Cuentas",
  "Cupo oral",
  "Cupo póster",
  "Cupos e inscripciones",
  "Currículum",
  "custom",
  "CV",
  "CV / reseña",
  "Dados gerais, identidade visual, idiomas e permissões.",
  "dark",
  "dashboard",
  "Datos del envío",
  "Datos generales y estructura que utilizan todos los módulos.",
  "Datos generales, identidad visual, idiomas y permisos.",
  "Days, rooms, sessions and ordered participations.",
  "de",
  "de todos los arbitrajes válidos y se respeta el ranking.",
  "De:",
  "Definí cuándo debe ejecutarse cada proceso, qué comunicaciones corresponden y quién debe recibirlas.",
  "degraded",
  "Del conocimiento a la práctica.",
  "Denominación *",
  "Desasignar",
  "Descargá meetingPlanner",
  "Descargalo o recibilo directamente",
  "Descargar archivo",
  "Descargar credenciales (.txt)",
  "Descargar original y corrección",
  "Descargar PDF",
  "Descargar preguntas y respuestas",
  "Descargar programa por idioma",
  "Descargar reporte",
  "Describe el ciclo de vida; la disponibilidad se configura por separado.",
  "Descripción",
  "Descripción y tareas",
  "desde",
  "desde una punta hasta la opuesta",
  "Desenlazar WhatsApp",
  "Destinatarios",
  "destinatarios ·",
  "Destino no disponible",
  "Detallar nombres de participantes",
  "Detalle de consumo de los últimos 30 días",
  "Detalle del proceso, responsables o condiciones necesarias",
  "Detectar entradas",
  "Detectar entradas de audio",
  "Detener y generar preguntas",
  "Días del evento",
  "Días, salas, sesiones y participaciones en orden.",
  "Dias, salas, sessões e participações em ordem.",
  "días.",
  "dígitos de acceso",
  "Dirección de correo adicional",
  "Discusión por trabajo (minutos)",
  "Diseño actual · lista y programa",
  "Diseño de selección de eventos guardado.",
  "Diseño general de meetingPlanner, antes de ingresar a un congreso. Se aplica a todos los usuarios.",
  "Disponible cuando el programa preliminar del subevento esté finalizado.",
  "Disponible para acciones del Organigrama",
  "Disponible para administrar y seleccionar en el panel",
  "Disponible para asignaciones",
  "Disponible para nuevas asignaciones",
  "Disponible para usuarios internos y faculty que ya tengan una clave configurada.",
  "Dispositivo anónimo",
  "Dispositivo de entrada",
  "Dispositivo sin identificar",
  "dispositivos",
  "Dispositivos registrados:",
  "Distribuição por tema, pontuações, acompanhamento das avaliações e comunicações aos autores.",
  "Do conhecimento à prática.",
  "document",
  "Download meetingPlanner",
  "downloads",
  "Dr.",
  "Dra.",
  "drafts",
  "duplicados ·",
  "Duración",
  "Duración de la aparición",
  "Duración predeterminada",
  "E-mail, WhatsApp, expositores, patrocinadores, relatórios e programas em PDF para cada etapa.",
  "Edición de la sesión",
  "Editá el nombre antes de @virtualmedica.com. Conservás la misma bandeja y los correos existentes; la dirección anterior seguirá recibiendo mensajes.",
  "Editar borrador",
  "Editar faculty de All",
  "Editar los datos no cambia la selección de esta persona en Event.",
  "Editar sesión",
  "Ej. Cambio de salón",
  "Ej. Congreso Médico 2027",
  "Ej. Coordinación científica",
  "Ej. Entrada principal",
  "Ej. Enviar primera ronda de invitaciones",
  "Ej. ePoster 16:9 claro",
  "Ej. Jueves 22",
  "Ej. Latinoamericanos",
  "Ej. Mesa 1 · Cardiología clínica",
  "Ej. Nuevos desafíos en cardiología clínica",
  "Ej. Planta baja",
  "Ej. Primera franja",
  "Ej. Programa preliminar finalizado",
  "Ej. Recordatorio",
  "Ej. Representante comercial",
  "Ej. Reunión de coordinación científica",
  "Ej. Sociedad Argentina de Cardiología",
  "Ej.: Premio joven investigador",
  "El abstract todavía no está disponible.",
  "El audio original se conserva. Cada oyente recibe voz y subtítulos en el idioma que seleccione.",
  "El audio puede grabarse. Para generar las preguntas debe estar habilitada la IA de Organize con crédito y una clave de transcripción; después podrás reintentar sin volver a grabar.",
  "El backend todavía no informó el UUID. Actualizá y reiniciá Organize.",
  "El banner",
  "El banner del evento",
  "El consumo es estimado a partir de tokens y las tarifas técnicas definidas en .env; no reemplaza la facturación del proveedor.",
  "El encabezado de email",
  "El evento, siempre a mano.",
  "El faculty tendrá el acceso en su portal. La traducción simultánea es opcional.",
  "El grupo se recalcula al procesar el hito. Los filtros de abajo reemplazan el subevento y el tipo de Faculty generales. Se guarda una copia de los criterios; editar luego un grupo guardado no cambia este hito.",
  "El icono de WhatsApp",
  "El ícono identifica los grupos de WhatsApp y el banner encabeza Organize y Abstracts.",
  "El logo",
  "El logo y banner se toman de la ficha del expositor seleccionado.",
  "El navegador muestra las entradas que reconoce el sistema operativo. Conectá primero la consola o el dispositivo USB.",
  "El Organigrama sólo muestra comunicaciones que incluyen el canal email. Al procesar, el target se calcula con los filtros definidos arriba.",
  "El participante “Organize · Traducción” entra con cámara y micrófono apagados. No requiere instalar nada en tu computadora.",
  "El personal de esta empresa podrá usar meetingPlanner para convertir un celular en emisor de presencia de sus stands.",
  "El pie y el banner se incorporarán automáticamente a las comunicaciones vinculadas con esta sesión.",
  "El plano no puede superar los 10 MB",
  "El programa avanza con una base sólida",
  "el programa completo",
  "el promedio general ponderado",
  "El resumen todavía no está disponible.",
  "El título, los autores y los centros siempre se muestran cuando esta opción está habilitada.",
  "Elegí el micrófono, la entrada de línea o USB. La grabación dura el tiempo de la sesión (",
  "Elegí el nombre de la casilla. Organize comprobará que esté disponible, la creará en el servidor y generará su contraseña segura automáticamente.",
  "Elegí un MP3, WAV, M4A o WebM de esta computadora. Se usa para esta prueba y no modifica el archivo guardado en el evento.",
  "Elegí una contraseña de al menos 6 caracteres. Este enlace puede utilizarse una sola vez.",
  "Eliminar clave guardada",
  "Eliminar hito",
  "Eliminar participante",
  "Eliminar sesión",
  "email",
  "Email",
  "Email · Audiencia configurada:",
  "Email *",
  "Email de acceso *",
  "Email de contacto",
  "Email de destino",
  "Email de prueba",
  "Email del asistente",
  "Email, WhatsApp, exhibitors, sponsors, reports and PDF programs for every stage.",
  "Email, WhatsApp, expositores, auspiciantes, reportes y programas PDF para acompañar cada etapa.",
  "Email:",
  "Emails previstos",
  "Emails que deben enviarse",
  "Emitiendo…",
  "Emitir invitación ahora",
  "Emitir invitaciones pendientes",
  "Empezá a escribir…",
  "Empresa expositora *",
  "Empresas y stands comerciales",
  "En Ajustes → Inteligencia artificial, cargá la API Key del evento y habilitá IA para Organize.",
  "En curso",
  "en esta planta",
  "En evaluación",
  "En organización",
  "En planificación",
  "en un archivo PDF.",
  "En vivo",
  "Enable translation channels for sessions and bring content to participants in different languages.",
  "ENCABEZADO",
  "Encabezado de emails",
  "English",
  "Enlace",
  "Enlace de invitación del grupo",
  "Enlace de la sala",
  "Enlace pendiente",
  "Enlace privado",
  "Enlace privado de Call for Science",
  "Enlaces de Call for Science",
  "ENLAZADO",
  "ENLAZAR",
  "Entidad administradora *",
  "Entidad organizadora *",
  "Entidades organizadoras, sus administradores y los eventos que pueden gestionar.",
  "Entrada",
  "Entrada de audio",
  "Entrada en vivo",
  "Entrada predeterminada del sistema",
  "Entre (inclusive)",
  "Entregada",
  "Enviado",
  "enviados",
  "Enviando…",
  "Enviar",
  "Enviar agenda",
  "Enviar al grupo",
  "Enviar al grupo revisado",
  "Enviar código por WhatsApp",
  "Enviar comunicación",
  "Enviar comunicado",
  "Enviar correo de recuperación",
  "Enviar invitaciones por email y",
  "Enviar PDF",
  "Enviar por email",
  "Enviar por WhatsApp",
  "Enviar presentación",
  "Enviar presentación por WhatsApp",
  "Enviar push ahora",
  "Enviar push rápido",
  "Enviar también desde otra cuenta",
  "Enviar WhatsApp",
  "envíos adicionales con error o sin confirmación. Los correos principales no se reenviaron.",
  "Envíos segmentados y trazables",
  "ePoster",
  "error",
  "es",
  "Es árbitro de trabajos científicos",
  "Es la jornada inicial del evento",
  "es,en,pt",
  "Escaneá el código QR",
  "Escribí al grupo…",
  "Escribí el mensaje que aparecerá en los teléfonos…",
  "Escribí el primer mensaje en el grupo.",
  "Escribí el primer mensaje o enviá una comunicación al faculty.",
  "Escribí los títulos que aparecerán como opciones dentro de cada modalidad.",
  "Escuchá la traducción en sesiones habilitadas y participá de quizzes durante las actividades.",
  "Escuchar en",
  "Escuchar grabación y ver resumen",
  "Espacios del evento",
  "Espacios físicos y transmisiones",
  "Español",
  "Espejo en SQL Server",
  "Esperando audio",
  "Esperando enlace",
  "Esperando la voz del expositor…",
  "Esperando señales actualizadas. No se muestran presencias antiguas como actuales.",
  "Esquema de stands · distribución ilustrativa, sin plano disponible",
  "Esta imagen y este color se utilizan en Organize y Call4Science para este evento.",
  "Esta mesa todavía no tiene trabajos asignados.",
  "Esta sesión finalizó sin audio grabado. Podés iniciar una nueva captura desde este panel.",
  "Esta sesión finalizó sin una grabación de audio válida.",
  "Estaciones de aprendizaje",
  "Estações de aprendizagem",
  "Estado",
  "Estado actual de Abstracts",
  "Estado actual de Organize",
  "Estado de las participaciones",
  "Estado del evento",
  "Estado del faculty",
  "Estado del programa",
  "Estado interno del hito",
  "Estados del evento",
  "Estamos iniciando WhatsApp Web. Esto puede demorar algunos segundos.",
  "Estas credenciales son independientes de los usuarios de Organize y permiten registrar visitas desde la app.",
  "Este faculty todavía no tiene una clave. Completá ambos campos para habilitar el acceso por email y contraseña.",
  "Este faculty ya tiene una clave. Completá ambos campos solamente si querés reemplazarla.",
  "Este formato debe descargarse y abrirse con la aplicación correspondiente.",
  "Este formato se descarga y abre con la aplicación correspondiente.",
  "Este grupo ya existe en WhatsApp. Sólo falta recuperar su enlace de invitación; no se creará otro grupo.",
  "Este grupo ya existe. Podés abrirlo o reenviar la invitación únicamente a quienes todavía no se unieron.",
  "Este mensaje no contiene texto legible. Podés abrirlo en el webmail para ver su formato original.",
  "Este usuario podrá administrar todos los eventos de",
  "Este usuario quedará vinculado a la empresa seleccionada.",
  "Este valor será el utilizado para ordenar y aplicar los puntos de corte.",
  "Estos ítems y sus pesos se aplican únicamente a",
  "Estructura del evento",
  "Estructura del programa",
  "Etapa general",
  "Etapas operativas que el Organigrama puede aplicar al procesar un hito",
  "Etiqueta",
  "event",
  "Event",
  "Evento",
  "Evento #",
  "Evento activo",
  "Evento activo ·",
  "Evento eliminado",
  "evento@dominio.com",
  "eventos",
  "Eventos",
  "Eventos registrados",
  "events",
  "Everything behind a great event.",
  "exhibitor",
  "Exige validar email o WhatsApp antes de acceder al evento.",
  "Explorá disertantes, guardá actividades favoritas y consultá el programa descargado en la app nativa.",
  "Explore palestrantes, salve atividades favoritas e consulte o programa baixado no aplicativo nativo.",
  "Explore speakers, save favorite activities and consult the downloaded program in the native app.",
  "Exportar CSV",
  "Expositores",
  "Facturación oficial de OpenAI",
  "faculty",
  "Faculty",
  "faculty confirmado",
  "Faculty de este evento y de congresos anteriores del mismo organizador. Marcá o desmarcá para incluirlo o quitarlo de Event.",
  "Faculty de la sesión",
  "Faculty en Event",
  "Faculty identificado",
  "Faculty incluido en este evento.",
  "Faculty invitado",
  "Faculty por país",
  "Faculty y disertantes",
  "Faculty, organizadores, usuários e expositores.",
  "Faculty, organizadores, usuarios y expositores.",
  "Faculty, organizers, users and exhibitors.",
  "Falta el Project ID",
  "Faltan teléfonos",
  "Fecha",
  "Fecha *",
  "Fecha de cierre",
  "Fecha de cierre *",
  "Fecha de corrección",
  "Fecha de inicio",
  "Fecha de inicio *",
  "Fecha y hora *",
  "Filtrar faculty por estado",
  "Filtrar por día",
  "Filtrar por roles ·",
  "Filtrar por sala",
  "Filtrar usuarios por roles",
  "Finalidades e acesso",
  "Finalidades y acceso",
  "Finalizar meeting",
  "finished",
  "Firmantes de comunicaciones",
  "Flujo de organización y programa.",
  "Flujo de trabajos científicos y arbitraje.",
  "FO",
  "Follow every submission from reception through review and selection. An organized process for authors, reviewers and scientific committees.",
  "Fondo compartido del acceso",
  "Formación académica",
  "Formato de administración de agenda",
  "Formato del CSV, en este orden:",
  "Formato del email",
  "Formato preferido",
  "Formato:",
  "Formatos habilitados en Abstracts",
  "Formats, topics and deadlines for free papers, abstracts, clinical cases and ePosters.",
  "Foto del participante",
  "Foto profesional sugerida por IA",
  "Foto sugerida",
  "Foto sugerida aplicada al perfil",
  "Franjas configuradas para cada jornada",
  "Frase institucional o comercial",
  "From knowledge to practice.",
  "Fuente actual:",
  "Fuentes consultadas",
  "Fuera de Event",
  "Fuera de la temática o subevento configurado",
  "Fuera de Organize",
  "Función / cargo",
  "Función del firmante",
  "Funciones de cada participante",
  "General information, visual identity, languages and permissions.",
  "Generar código QR",
  "Geolocalización",
  "Geolocalización móvil.",
  "Gerenciar pessoas",
  "Gestión",
  "gestión integral",
  "Gestionar personas",
  "Gestionar trabajos",
  "Grabación de participación",
  "Grabación disponible",
  "Grabaciones y banco de preguntas",
  "Grabar",
  "Grilla por salas",
  "Grupo",
  "Grupo creado",
  "Grupo de destinatarios",
  "Grupo de la sesión",
  "Grupo de WhatsApp",
  "Grupo de WhatsApp de la sesión",
  "Grupo guardado",
  "Grupo ya creado",
  "Guardá las credenciales antes de cerrar. No se enviaron mensajes a los usuarios.",
  "Guardando…",
  "Guardar",
  "Guardar ajustes",
  "Guardar borrador",
  "Guardar cambios",
  "Guardar como otro grupo",
  "Guardar credenciales",
  "Guardar cuenta adicional",
  "Guardar datos generales",
  "Guardar diseño de inicio",
  "Guardar grupo",
  "Guardar hito",
  "Guardar selección por función",
  "Guardar ubicaciones",
  "Guía de organización · v",
  "Habilitá canales de traducción para las sesiones y acercá los contenidos a participantes de distintos idiomas.",
  "Habilitación, crédito y consumo",
  "Habilitado",
  "Habilitar Call for Science",
  "Habilitar Chat Interno",
  "Habilitar introducción del caso clínico",
  "Habilitar Meeting Live",
  "Habilitar Test de Envíos",
  "Habilite canais de tradução nas sessões e leve os conteúdos a participantes de diferentes idiomas.",
  "hard",
  "hasta",
  "Hay",
  "Heredar main sponsor del evento",
  "Historial",
  "Historial reciente (",
  "Hito eliminado",
  "hitos",
  "Hora de fin *",
  "Hora de inicio *",
  "Horario de ingreso y última detección en cada stand o sesión.",
  "How to organize an event",
  "IA",
  "IA habilitada para Call4Science",
  "IA habilitada para MeetingPlanner",
  "IA habilitada para Organize",
  "IA no disponible",
  "ICONO",
  "Ícono de WhatsApp",
  "Icono del evento para WhatsApp",
  "ID",
  "ID del trabajo *",
  "Identidad visual",
  "Identificación de asistentes",
  "Identificación del proyecto de OpenAI",
  "Idioma de las comunicaciones",
  "Idiomas",
  "Idiomas habilitados",
  "Idiomas oficiales del evento",
  "idle",
  "Igual a",
  "image",
  "Imagen de fondo del acceso",
  "Imágenes compartidas del evento",
  "Importación finalizada",
  "importados ·",
  "Importando…",
  "Importar CSV",
  "Importar faculty a All",
  "Importar usuarios",
  "Importe",
  "Inactivo",
  "Incluye el nombre del faculty, la sesión y el enlace. Los envíos no se pueden anular y se separan aleatoriamente entre 1 y 2 minutos.",
  "Incluye espacios. Se muestra en la pestaña de contenido del caso clínico.",
  "Incluye teléfonos que todavía no validaron ni registraron una persona.",
  "incoming",
  "Indicadores para seguir el programa y las invitaciones.",
  "Indicadores para seguir el programa, las invitaciones y el Call for Science.",
  "Inferior derecha",
  "Inferior izquierda",
  "info@virtualmedica.com",
  "Información académica pendiente.",
  "Información general",
  "Información profesional pendiente.",
  "Información que puede tratarse",
  "Informações que podem ser tratadas",
  "Information that may be processed",
  "Ingresá a tu cuenta",
  "Ingresá al menos dos caracteres para buscar en todo el evento.",
  "Ingresá la identificación completa del proyecto de OpenAI, comenzando con proj_.",
  "Ingresá tu email. Te enviaremos un enlace seguro; recién al abrirlo podrás crear una nueva contraseña.",
  "Ingresando…",
  "Ingresar al meeting embebido",
  "Ingresar al panel",
  "Ingresar con contraseña",
  "Ingreso:",
  "Iniciar arbitraje y notificar",
  "Inicio",
  "Insertá “Aceptar invitación” o “No participar” donde quieras. Podés editar su texto dentro del mensaje. Cada enlace registra la respuesta del faculty; en test no modifica datos.",
  "Institución",
  "Inteligencia artificial",
  "Inteligencia Artificial",
  "Inteligência artificial",
  "Intervención sin título",
  "inválidos.",
  "invitaciones",
  "Invitaciones, confirmaciones, accesos y datos profesionales.",
  "Invitado",
  "Ir a esta sección",
  "Ítem",
  "Ítems de evaluación",
  "Jitsi · servidor",
  "Jitsi desde el servidor · Prueba",
  "jornada",
  "Jornada *",
  "jornadas",
  "Jornadas y orden del programa",
  "JPG, PNG o WebP.",
  "KB",
  "KB recibidos. Podés cerrar este panel: la captura continúa en el servidor.",
  "La aplicación sigue operativa; SQL Server tiene reintentos pendientes.",
  "La app detecta balizas físicas y teléfonos emisores para registrar presencia en stands, salas y sesiones.",
  "La app móvil que conecta a cada asistente con lo que le interesa. El programa, su agenda personal y los contenidos del congreso lo acompañan durante la jornada.",
  "La asignación automática prioriza unidad temática, excluye autores y evita —en este orden— el mismo servicio y el mismo país.",
  "La asignación cruza la unidad temática del trabajo con las temáticas habilitadas para cada árbitro y distribuye la carga. Guardá los cambios antes de ejecutar manualmente.",
  "La bandeja se abrirá cuando la cuenta esté configurada.",
  "La búsqueda se actualiza mientras escribís.",
  "La captura se interrumpió antes del tiempo previsto. Las preguntas corresponden únicamente al audio recibido.",
  "La clave efectiva funciona",
  "La clave efectiva no pudo responder",
  "La consulta no devolvió información.",
  "La IA buscará una foto pública y preparará un resumen profesional y académico. Solo se enviaran nombre, institucion, pais y categoria a la plataforma de IA configurada para esta funcion.",
  "La IA está verificando identidad, foto y antecedentes públicos…",
  "La IA no encontró una foto pública suficientemente verificable.",
  "La imagen de encabezado, los firmantes y el pie general se incorporan al enviar.",
  "La imagen de fondo de Call for Science",
  "La imagen de splash",
  "La imagen no reemplaza la foto actual hasta que confirmes.",
  "La mayor oportunidad operativa está en completar confirmaciones de faculty y resolver los trabajos todavía pendientes de evaluación.",
  "La mayor oportunidad operativa está en completar confirmaciones de faculty.",
  "La mesa sólo podrá recibir trabajos presentados en este subevento.",
  "la métrica seleccionada",
  "La opción por sala requiere acceso validado en la app y una baliza activa asignada a esa sala. La escucha se interrumpe si no se renueva la detección durante 45 segundos.",
  "La persona deberá inscribirse antes de participar de esta sesión.",
  "La sesión finalizó. Estamos preparando el audio y el resumen…",
  "La sesión quedará guardada en este servidor para enviar invitaciones y comunicaciones.",
  "La transmisión comienza en",
  "La transmisión todavía no comenzó.",
  "Las jornadas, salas, agenda, faculty y trabajos pertenecen únicamente al evento seleccionado. Al eliminar un evento también se elimina toda su información asociada.",
  "Learning stations",
  "Libre",
  "Lic.",
  "Límite de crédito (USD)",
  "Límite duro",
  "Limpiar",
  "Línea",
  "list",
  "Listen to translation in enabled sessions and take part in live quizzes.",
  "live",
  "Local preferences and external services",
  "locations",
  "login",
  "Logo del expositor",
  "Los administradores del evento pueden administrar funciones y topes. Las credenciales sólo son accesibles para el superadministrador.",
  "Los cambios realizados en este correo se perderán.",
  "Los cambios se aplican al guardar. Desactivá una baliza para conservar su configuración sin utilizarla.",
  "Los datos están separados por evento",
  "Los destinatarios recibirán dos correos: uno desde la cuenta principal y otro desde esta cuenta, con el mismo contenido y adjuntos. Se aplica a los envíos manuales y automáticos del evento.",
  "Los dos circuitos son independientes.",
  "Los emails y WhatsApp directos se enviarán al asistente. Los grupos de sesiones conservarán el WhatsApp personal del faculty.",
  "Los filtros se combinan entre sí. Dentro de cada filtro alcanza con cumplir una de las opciones seleccionadas. Sin selección, ese filtro no restringe.",
  "Los pendientes continuarán enviándose aun si se reinicia el servidor.",
  "Los procesos automáticos comparten ese límite hasta que vuelvas a guardar la configuración. Se conservan los adjuntos. Los códigos y enlaces para ingresar o recuperar contraseñas enviados como prueba no habilitan accesos reales.",
  "Los usuarios se administran desde la tarjeta del organizador.",
  "mail",
  "Main sponsor del evento",
  "Main sponsor del subevento",
  "Mais espaço para as ideias que fazem a ciência avançar.",
  "major",
  "Major",
  "Manage people",
  "Mapa en vivo",
  "Marcando o moviendo esquina",
  "Más arbitrajes realizados",
  "Más grande",
  "Más lugar para las ideas que hacen avanzar la ciencia.",
  "Más pequeña",
  "Más recientes",
  "más recientes de",
  "master",
  "Material de la presentación",
  "Material de presentación",
  "Material para autores",
  "Máximo de caracteres de la introducción",
  "Máximo de caracteres por abstract",
  "Máximo de coautores",
  "Máximo de diapositivas por caso clínico",
  "Mayor o igual que",
  "Mayor que",
  "Medica",
  "Meeting eliminado",
  "Meeting Live",
  "Meeting programado",
  "meetingplanner",
  "MeetingPlanner",
  "meetingPlanner Organize · Acceso seguro para organización y faculty",
  "meetings",
  "Meetings",
  "Meetings por Real Time",
  "Menor → mayor concentración",
  "Menor o igual que",
  "Menor que",
  "Mensaje",
  "Mensaje *",
  "Mensaje de bienvenida en Abstracts",
  "Mensaje de correo",
  "Mensaje de email *",
  "Mensaje de registro obligatorio",
  "Mensaje de WhatsApp",
  "mensajes",
  "Mensajes de WhatsApp sin leer",
  "mensual",
  "Mes actual",
  "Mesa / sesión de pósters",
  "Mesa de orales",
  "Mesa de presentaciones orales",
  "Mesas científicas",
  "Mesas científicas y sesiones de pósters",
  "Mesas de orales y sesiones de pósters para asignar trabajos",
  "Mesas y sesiones",
  "Mi agenda",
  "Micrófono, línea o USB",
  "min",
  "min discusión",
  "min presentación +",
  "Mínimo 6 caracteres",
  "Minor",
  "minutos",
  "Minutos",
  "minutos ·",
  "Minutos posteriores",
  "Minutos previos",
  "Modalidad",
  "Modalidad de envío",
  "Modalidad de participación",
  "Modalidades",
  "Modalidades admitidas",
  "Modalidades, temas e prazos para temas livres, resumos, casos clínicos e ePosters.",
  "Modalidades, temáticas y fechas para temas libres, abstracts, casos clínicos y ePosters.",
  "Modelo",
  "Modelo actual del servidor",
  "Modelo protegido. Cada reenvío incluye solamente participaciones todavía sin respuesta.",
  "Modelos por función",
  "Módulo",
  "Módulos permitidos",
  "Montar a agenda",
  "month",
  "More room for ideas that advance science.",
  "Mostrar en programa",
  "Mostrar todos",
  "Nacionales, latinoamericanos, internacionales, industria y otras categorías",
  "Navegación principal",
  "new",
  "Nivel de entrada de audio",
  "No encontramos resultados",
  "No hay bloques configurados para esta jornada.",
  "No hay bloques para",
  "No hay coincidencias.",
  "No hay comunicaciones de envío individual. Agregalas primero desde el módulo Comunicaciones.",
  "No hay conversaciones registradas.",
  "No hay eventos configurados",
  "No hay faculty confirmados disponibles. Deben aceptar la invitación o ser marcados como Confirmado desde Faculty.",
  "No hay hitos en esta vista",
  "No hay meetings programados",
  "No hay mensajes en esta carpeta.",
  "No hay mesas activas compatibles.",
  "No hay mesas para este subevento. Crealas desde Ajustes → Mesas científicas.",
  "No hay participaciones rechazadas.",
  "No hay registros para mostrar.",
  "No hay sesiones",
  "No hay temáticas habilitadas para trabajos científicos. Podés configurarlas desde Ajustes → Temáticas.",
  "No hay usuarios con los roles seleccionados.",
  "No leído",
  "No modificar Abstracts",
  "No modificar Organize",
  "No participa",
  "No participan",
  "No publicar programa",
  "No se encontraron personas con ese nombre.",
  "No se encontraron resultados para “",
  "No se guardaron las credenciales",
  "No se obtuvieron fuentes públicas suficientes.",
  "No se pudo abrir el grupo de WhatsApp",
  "No se pudo actualizar el arbitraje",
  "No se pudo cargar el diseño de inicio. Volvé a abrir los ajustes.",
  "No se pudo cargar la bandeja.",
  "No se pudo cargar la configuración.",
  "No se pudo consultar OpenAI",
  "No se pudo copiar",
  "No se pudo eliminar",
  "No se pudo generar el código QR",
  "No se pudo importar",
  "No se pudo traducir la página",
  "No tiene sesiones asignadas.",
  "No vinculado",
  "Nombre",
  "Nombre *",
  "Nombre corto",
  "Nombre corto *",
  "Nombre de esta planta",
  "Nombre de la casilla",
  "Nombre de la modalidad *",
  "Nombre de la nueva planta",
  "Nombre de la sala *",
  "Nombre de la temática *",
  "Nombre de sala Real Time",
  "Nombre del asistente",
  "Nombre del bloque *",
  "Nombre del estado *",
  "Nombre del evento",
  "Nombre del evento *",
  "Nombre del expositor *",
  "Nombre del firmante",
  "Nombre del grupo *",
  "Nombre del grupo reutilizable",
  "Nombre del remitente",
  "Nombre del remitente adicional",
  "Nombre del rol *",
  "Nombre del tipo *",
  "Nombre plural",
  "Nombre que identifique estos criterios",
  "Nombre remitente",
  "Nombre visible",
  "Nombre y apellido",
  "Nombre y apellido (una columna), email, teléfono, subevento, contraseña.",
  "nombre@dominio.com",
  "nombre@ejemplo.com",
  "Notificaciones",
  "Nueva clave",
  "Nueva clave (opcional)",
  "Nueva contraseña",
  "Nueva contraseña (opcional)",
  "Nueva plantilla",
  "Nueva sesión",
  "Nuevo evento",
  "Nuevo faculty",
  "Nuevo hito",
  "Nuevo organizador",
  "Nuevo rol",
  "Nuevo trabajo",
  "Nuevo usuario",
  "Número vinculado",
  "O aplicativo móvel que conecta cada participante ao que lhe interessa. O programa, a agenda pessoal e os conteúdos do congresso o acompanham durante o dia.",
  "O evento, sempre à mão.",
  "Objetivos",
  "Objetivos y descripción breve de la sesión",
  "Oficinas e atividades",
  "Opcional. Usá letras minúsculas, números o guiones; debe ser único entre todos los eventos.",
  "openai",
  "OpenAI Admin API Key para consumo",
  "OpenAI API Key del evento",
  "OpenAI no informó consumos para este período.",
  "Operación",
  "Operaciones registradas localmente durante los últimos",
  "oral",
  "Oral",
  "Orales",
  "Orden",
  "Orden de aparición",
  "organigram",
  "Organigrama",
  "Organizá horarios, salas, temáticas y modalidades.",
  "Organizá la participación según la capacidad de cada actividad.",
  "Organizá las actividades formativas que necesitan una dinámica propia. Talleres, participantes y estaciones de trabajo, con una gestión enfocada en la experiencia de aprendizaje.",
  "Organización científica, simplificada",
  "Organizador *",
  "Organizador activo",
  "Organizadores",
  "organize",
  "Organize",
  "Organize a participação conforme a capacidade de cada atividade.",
  "Organize atividades formativas que precisam de uma dinâmica própria. Oficinas, participantes e estações de trabalho com uma gestão focada na experiência de aprendizagem.",
  "Organize attendance according to the capacity of each activity.",
  "Organize learning activities with a rhythm of their own. Workshops, participants and workstations, managed around the learning experience.",
  "Organize, Abstracts, meetingPlanner y Workshop dejarán de poder enviar mensajes hasta que se vincule nuevamente.",
  "Organize:",
  "organizer",
  "organizers",
  "Origen",
  "Oscuro",
  "Ouça a tradução nas sessões habilitadas e participe de quizzes durante as atividades.",
  "outgoing",
  "País",
  "País sin informar",
  "País:",
  "Países",
  "países representados",
  "Pantalla de selección de eventos",
  "Papelera",
  "Para",
  "Para continuar, registrate y validá tu email o WhatsApp.",
  "Para micrófono, línea o USB mantené esta pantalla abierta y el dispositivo activo. Video Meeting se captura en el servidor y puede continuar al cerrar esta pantalla. Al finalizar se generan las preguntas en el servidor.",
  "Para WhatsApp y Push se enviará automáticamente una versión en texto plano.",
  "Para:",
  "Parte inferior",
  "Parte superior",
  "Participación",
  "Participación a grabar",
  "Participaciones",
  "Participaciones rechazadas",
  "participaciones y no se encontraron conflictos horarios.",
  "participantes",
  "Participantes",
  "participantes asignados",
  "Participantes por confirmar",
  "Pasá el cursor o tocá una persona, un grupo o un stand para ver su identificación.",
  "Pasá el cursor sobre una persona para identificarla. Seleccioná un grupo para ver a todos.",
  "password",
  "Pausar",
  "pdf",
  "PDF",
  "PDF del trabajo",
  "PDF, corrección y presentación",
  "Peer review and selection",
  "pendiente",
  "Pendiente",
  "Pendiente de cargar",
  "pendientes",
  "Pendientes",
  "pendientes ·",
  "Pendientes de confirmación",
  "Pendientes de ubicación",
  "Perfil profesional",
  "Perfil sugerido por IA",
  "Permisos",
  "Permite administrar otras cuentas y roles",
  "Permite asignarle las unidades temáticas que podrá evaluar.",
  "Permite vincular trabajos científicos",
  "Permitir emisión de geolocalización",
  "Permitir ver el abstract",
  "Permitir ver la presentación PPT",
  "Permitir visualizar y descargar el PDF",
  "Persona",
  "Personal asociado",
  "Personal con acceso móvil",
  "Personalizá los textos que verá el autor al ingresar a Call4Science para este evento.",
  "Personalizar filtros…",
  "personas",
  "Personas y grupos",
  "Peso",
  "Pie general de email",
  "Plan maestro del evento",
  "Planificado",
  "Planificados",
  "Plano de asistentes en stands",
  "Planta",
  "Planta *",
  "Planta creada. Ahora ubicá los stands sobre la imagen.",
  "Planta y stands guardados. Balizas y ubicaciones guardadas.",
  "Plantas y stands",
  "Plantilla protegida: podés modificar sus textos y configuración, pero no eliminarla.",
  "plantillas",
  "Plantillas",
  "Plantillas de presentación",
  "Plataforma",
  "Plataforma integrada de gestión de eventos científicos",
  "Plataformas de inteligencia artificial",
  "Podés cargar una grabación y reproducirla desde una sesión para probar la captura, las traducciones y la escucha móvil.",
  "Podés dejarlo vacío; se genera a partir del nombre.",
  "Podés publicar varias bases por evento y por tipo de trabajo.",
  "Podés retirar una de las sesiones marcadas antes de descargarla.",
  "Podés seleccionar uno o varios bloques contiguos.",
  "Podés usar letras, números, punto, guion y guion bajo.",
  "Podrá validarse en la app y registrar visitas voluntarias mediante QR.",
  "Portada izquierda del acceso a Organize",
  "portrait",
  "Português",
  "Posición en pantalla",
  "poster",
  "póster",
  "Póster",
  "Pósters",
  "Preferências locais e serviços externos",
  "Preferencias locales y servicios externos",
  "Prefijo",
  "Preparación",
  "Preparado",
  "Preparado, todavía sin activar.",
  "Preparando código QR…",
  "Preparando tu evento…",
  "Preparando vista previa…",
  "Preparar audio traducido",
  "Presença em salas e estandes",
  "Presença, localização e tradução",
  "Presence in rooms and stands",
  "Presence, location and translation",
  "PRESENCIA DEL EVENTO",
  "Presencia en los stands",
  "Presencia en salones y stands",
  "Presencia, ubicación y traducción",
  "Presencial",
  "presencias actuales",
  "Presentación / archivo",
  "Presentación cargada correctamente",
  "Presentación enviada por WhatsApp",
  "Presentación final",
  "Presentación pendiente",
  "Presentación por trabajo (minutos)",
  "Presentaciones científicas",
  "Presentaciones orales",
  "Presentado:",
  "presentes",
  "Primer administrador *",
  "Primero agregá un expositor activo al evento.",
  "Primero agregá una planta en “Plantas y stands”. Después podrás asociar las balizas de este lugar.",
  "Primero configurá las salas",
  "Primero configurá los días",
  "Primero creá las mesas desde Ajustes → Mesas científicas.",
  "Primero creá usuarios con rol Expositor desde Usuarios.",
  "Primero tenés que crear al menos un día del evento.",
  "Probá los mensajes antes de enviarlos a los destinatarios del evento.",
  "Probá modificando los filtros o la búsqueda.",
  "Probá primero la recuperación automática. Si WhatsApp vuelve a rechazarla, copiá el enlace desde “Info. del grupo → Enlace de invitación” y pegalo aquí.",
  "Procesado",
  "Procesados",
  "Procesando",
  "Procesando…",
  "Procesar hito",
  "Procesará nuevamente las invitaciones pendientes del subevento.",
  "Proceso *",
  "processing",
  "Prof.",
  "Program and faculty coordination",
  "Programa científico",
  "Programa científico interactivo",
  "Programa completo",
  "Programa disponible en la app",
  "Programa e palestrantes sob controle",
  "Programá el cierre, la asignación automática y la apertura del portal de arbitraje.",
  "Programa final",
  "Programa general",
  "Programa no disponible",
  "Programa preliminar finalizado",
  "Programa público",
  "Programá reuniones, seleccioná participantes y enviá las invitaciones.",
  "Programa y faculty bajo control",
  "Programa y trabajos",
  "Programa, faculty, trabajos, comunicaciones y reportes en una plataforma pensada para equipos médicos.",
  "Programado",
  "Programar e invitar",
  "Programar meeting",
  "proj_…",
  "Promedio general ponderado",
  "Protegida · editable, no eliminable",
  "Próximas actividades",
  "Próximo",
  "Próximos",
  "Próximos 30 días",
  "Proyecto",
  "Proyectos de la organización",
  "Publicación en meetingPlanner",
  "Publicado en Mobile",
  "Publicar programa definitivo",
  "Publicar programa preliminar",
  "Publicar trabajos científicos",
  "Puede completarse manualmente o mediante IA",
  "Puerto",
  "Puntaje",
  "Puntaje hasta",
  "Puntaje promedio",
  "Puntaje promedio del trabajo",
  "Puntaje promedio: mayor a menor",
  "Puntaje promedio: menor a mayor",
  "Puntaje utilizado para la clasificación",
  "Punto de corte para póster",
  "Punto de corte para presentación oral",
  "Puntos de corte y cupos",
  "Purposes and access",
  "Push",
  "Qué representa este estado dentro de su circuito",
  "Quién está en cada stand",
  "Quién puede escuchar",
  "Quitar",
  "Quitar actual",
  "Quitar audio de prueba actual",
  "Quitar foto actual",
  "Quitar imagen actual",
  "Quitar participación",
  "Quitar persona",
  "quizzes",
  "Reabrir hito",
  "ready",
  "Reanudar",
  "Reasigná el faculty y devolvé la participación a pendiente para emitir una nueva invitación.",
  "Reasignar faculty",
  "Recepção científica, seleção, relatórios e métricas.",
  "Recepción científica, selección, reportes y métricas.",
  "Recepción y arbitraje de trabajos",
  "Recepción y evaluación de trabajos",
  "Recepción, evaluación por jurados y resolución final.",
  "Rechazada",
  "Rechazado",
  "Rechazados",
  "Recibidos",
  "Recibirás",
  "Reconectando",
  "Reconectando actualizaciones",
  "Recuperación segura",
  "Recuperar contraseña",
  "Redactar",
  "Redactar correo",
  "Reemplazar",
  "Reenviar",
  "Reenviar a quienes aún no se unieron",
  "Refina el target del hito según el tipo asignado en el ABM de Faculty.",
  "Registró",
  "Registro de Presencia al Acceso",
  "Registro eliminado",
  "Registro obligatorio en la app",
  "registros incluidos en este resultado",
  "Reglamento del evento",
  "Reintentar",
  "Reintentar errores",
  "Reintentar generación",
  "rejected",
  "Repetí la nueva clave",
  "replicados",
  "REPORTE DE DISPOSITIVOS",
  "Reportes",
  "reports",
  "Requiere busqueda web. DeepSeek: deepseek-v4-pro.",
  "Requiere la integracion de audio de OpenAI.",
  "Requiere registro previo",
  "Requiere Registro Previo",
  "research",
  "Resguardo de datos",
  "Resolución científica",
  "Responder",
  "Responder a todos",
  "Respondido ·",
  "Responsable",
  "Responsable *",
  "Responsable de comunicaciones",
  "Respuestas del faculty",
  "Restablecer tipografía a 100%",
  "Resumen",
  "Resumen académico",
  "Resumen del evento",
  "Resumen del trabajo",
  "Resumen ejecutivo",
  "Resumen profesional",
  "Retention and protection",
  "Retirado por el autor",
  "Retirados",
  "Revisá la identidad antes de aplicarla",
  "Revisá tu WhatsApp",
  "Rol",
  "Rol en este evento *",
  "Rol, sesión, respuesta, modalidad y material deben coincidir en una misma participación. Se excluyen las sesiones canceladas. Los faculty que no participan se incluyen sólo si seleccionás ese estado.",
  "Roles",
  "roles configurados",
  "Roles de acceso",
  "room",
  "Rubro",
  "s de audio",
  "Sala",
  "Sala asignada automáticamente a las participaciones Video Meeting. La traducción comienza sólo al pulsar Conectar.",
  "Sala presencial",
  "Sala Real Time",
  "Sala Video Meeting de la sesión",
  "Salas",
  "Salas activas",
  "Saldo del límite del proyecto",
  "Saldo disponible",
  "Salida",
  "Salón por confirmar",
  "Salones *",
  "schedule",
  "scheduled",
  "Scientific submissions, selection, reports and metrics.",
  "Se actualizarán los trabajos evaluados como Oral, Póster o Rechazado según el ranking.",
  "Se agrega en letra pequeña y gris al final de todos los emails del evento.",
  "Se analizaron",
  "Se aplica a emails, WhatsApp, invitaciones y mensajes escritos en los chats. La traducción no está limitada por los idiomas configurados arriba.",
  "Se aplica a emails, WhatsApp, invitaciones y mensajes escritos en los chats. La traducción no está limitada por los idiomas configurados para el evento.",
  "Se controlará y registrará el ingreso presencial a la sesión.",
  "Se creará un grupo administrado por la cuenta de WhatsApp vinculada. Cada integrante recibirá individualmente el enlace para unirse.",
  "Se cuentan todos los caracteres visibles, incluidos espacios.",
  "Se encontraron",
  "Se genera automáticamente",
  "Se genera automáticamente si se deja vacío",
  "Se generan al guardar y se reutilizan en Call 4 Science. Las traducciones conservan el formato HTML.",
  "Se guarda junto con las credenciales y se recupera desde la base de datos.",
  "Se incluyen autores con al menos un trabajo que cumpla todas las condiciones; se excluyen borradores y trabajos retirados.",
  "Se muestra en un modal con el botón CONTINUE.",
  "Se muestran las",
  "Se programará al recuperar el enlace",
  "Se registra al abrir la app",
  "se superpone con",
  "Se usa",
  "Se usa el banner de la ficha del expositor; si falta, su logo. Sin lista propia se conserva el auspiciante seleccionado o la herencia del evento.",
  "Se usarán las credenciales SMTP definidas en el archivo .env del servidor.",
  "Se utilizará en el programa y en todas sus participaciones. JPG, PNG o WebP, hasta 2 MB.",
  "Se valida automáticamente al cargar un archivo PPTX.",
  "Sede",
  "Sede a confirmar",
  "segment",
  "Seguimiento de concurrencia",
  "Seguimiento de respuestas",
  "Segundos",
  "Segundos antes del fade out.",
  "segundos. Abrí esta sesión en la app, tocá “Traducción simultánea” y activá el audio.",
  "Seguridad",
  "Seguridad y acceso",
  "Seguridad y puerto",
  "Selección para Organize, Abstracts y MeetingPlanner.",
  "Seleccioná la dirección y copiala manualmente.",
  "Seleccioná las sesiones que querés conservar",
  "Seleccioná o creá una mesa científica.",
  "Seleccioná o escribí un proceso",
  "Seleccioná un mensaje para leerlo o redactá uno nuevo.",
  "Seleccioná un subevento para ver sus mesas disponibles.",
  "Seleccioná una mesa compatible con el formato",
  "Seleccioná una plantilla y su target",
  "Seleccioná uno o varios salones contiguos según el orden configurado.",
  "Seleccioná uno o varios; se intentarán enviar al mismo tiempo.",
  "Seleccionado:",
  "Seleccionar",
  "Seleccionar archivo",
  "Seleccionar archivo CSV",
  "Seleccionar área",
  "Seleccionar empresa…",
  "Seleccionar foto",
  "Seleccionar imagen",
  "Seleccionar jornada",
  "Seleccionar modelo",
  "Seleccionar MP3 o audio",
  "Seleccionar organizador…",
  "Seleccionar rol…",
  "Seleccionar sobre el mapa real",
  "Seleccionar subevento",
  "Seleccionar…",
  "sent",
  "Separador coma o punto y coma; encabezado opcional. Subevento: nombre o ID del evento activo; vacío significa todos. Contraseña vacía: se genera una clave de 6 caracteres con mayúscula, número y carácter especial, sin I, O ni l. Los emails duplicados se omiten.",
  "Será una evaluación adicional y no reemplazará la decisión del comité.",
  "server-jitsi",
  "Servidor meetingPlanner (configurado en .env)",
  "Servidor SMTP",
  "Servidor SMTP del evento",
  "Servidor SMTP personalizado para este evento",
  "Sesión",
  "Sesión auspiciada por",
  "Sesión científica",
  "Sesión de pósters",
  "Sesión eliminada",
  "Sesión finalizada",
  "Sesión relacionada",
  "sesiones",
  "Sesiones",
  "Sesiones confirmadas",
  "Sesiones por temática",
  "sesiones programadas",
  "Sesiones, faculty, trabajos, comunicaciones, expositores…",
  "Sesiones, salas, horarios, invitaciones y presentaciones, con detección de superposiciones.",
  "session",
  "Sessions, rooms, schedules, invitations and presentations, with overlap detection.",
  "Sessões, salas, horários, convites e apresentações, com detecção de sobreposições.",
  "settings",
  "setup",
  "Seus direitos e comunicações",
  "Si hay sala de espera, el moderador debe admitir al participante. El audio recibido se grabará y se enviará a traducción.",
  "Si la sesión tiene auspiciante, se agregará automáticamente a email y WhatsApp.",
  "Si la sesión tiene un auspiciante asignado directamente, se agregará automáticamente a email y WhatsApp.",
  "Si se desactiva, se muestran las funciones y presentaciones del programa sin identificar a las personas.",
  "Siguiente",
  "Siguientes",
  "Simultaneous translation",
  "Simultaneous translation and participation",
  "Sin archivo original",
  "Sin asistentes detectados ahora.",
  "Sin auspiciante",
  "Sin autenticación",
  "Sin autores informados.",
  "Sin balizas asignadas.",
  "Sin cifrado",
  "Sin clave configurada",
  "Sin código de stand",
  "Sin comunicaciones asociadas",
  "Sin confirmar",
  "Sin declarar",
  "Sin email",
  "Sin entidad asignada",
  "Sin estado aplicado",
  "Sin evaluar",
  "Sin imagen",
  "Sin información académica verificable.",
  "Sin información profesional verificable.",
  "Sin informar",
  "Sin main sponsor",
  "Sin mensajes todavía",
  "sin mesa",
  "Sin mesa asignada",
  "Sin modalidad",
  "Sin opciones configuradas para este evento.",
  "Sin país",
  "Sin PDF",
  "Sin plano cargado",
  "Sin puntaje",
  "Sin reglamento",
  "Sin resultados",
  "Sin resumen",
  "Sin rol",
  "Sin sesión del programa",
  "Sin subevento",
  "Sin subevento / sin firmantes",
  "Sin subeventos asignados",
  "Sin subeventos. Las sesiones aparecerán dentro de “Programa general”.",
  "Sin superposiciones",
  "Sin teléfono",
  "Sin teléfono configurado",
  "Sin temática",
  "Sin temática asignada",
  "Sin tipo asignado",
  "Sin trabajos",
  "Sin unidad temática",
  "Sin unidades temáticas asignadas",
  "Sin usuarios administradores asignados.",
  "Sin voz detectada todavía",
  "Sin WhatsApp",
  "Sin WhatsApp declarado",
  "Sincronización automática funcionando.",
  "Slogan",
  "smtp.dominio.com",
  "smtp.tudominio.com",
  "solaci2027",
  "Solicito recibir este único envío en el dato indicado.",
  "Solo las modalidades activas podrán seleccionarse al crear un trabajo.",
  "Sólo personas detectadas por balizas en la sala de la sesión",
  "Solo se muestran las temáticas configuradas para Trabajos científicos o Ambos.",
  "source",
  "speaker",
  "speakers",
  "SPLASH",
  "Splash de la app móvil",
  "square",
  "stand",
  "Stand",
  "STAND SELECCIONADO",
  "Stands",
  "Stands sin ubicación dibujada en el plano",
  "STARTTLS",
  "STARTTLS · 587",
  "Sua agenda, mesmo sem conexão",
  "Subdominio personalizado de Call for Science",
  "subevento",
  "Subevento",
  "Subevento *",
  "Subevento y firmantes",
  "subeventos",
  "Subeventos que puede corregir",
  "Subeventos, estados y firmantes",
  "Subí el plano de una planta para ubicar los stands.",
  "Subiendo plantilla",
  "Subir plantilla",
  "Subir una grabación",
  "Subtítulo de Organize",
  "Subtítulos",
  "Sumá revisión asistida, comentarios y una devolución de los trabajos para complementar la evaluación científica del comité.",
  "Superior derecha",
  "Superior izquierda",
  "superposición",
  "superposiciones.",
  "Tablas maestras",
  "Tailored calls for submissions",
  "Talleres y actividades",
  "Tamaño de tipografía",
  "Tamaño de tipografía del sitio",
  "Target *",
  "Teléfono",
  "Teléfono del asistente",
  "Tema de la participación",
  "temática",
  "Temática",
  "Temática / modalidad",
  "temáticas",
  "Temáticas",
  "Template",
  "Test de Envíos",
  "text",
  "Texto descriptivo",
  "Texto legal, datos de contacto o instrucciones generales",
  "Texto para buscar",
  "Texto que estará disponible para el arbitraje humano y por IA",
  "Texto superior",
  "Texto superior de Organize",
  "Textos del acceso a Call4Science",
  "Textos del acceso a Organize",
  "Textos propios de Organize para este evento. El fondo se configura en Identidad visual.",
  "The mobile app that connects each attendee with what matters to them. The program, personal agenda and conference content stay with them throughout the day.",
  "Tipo",
  "Tipo *",
  "Tipo de Faculty",
  "Tipo de usuario / rol *",
  "Tipos de Faculty",
  "Título",
  "Título *",
  "Título / intervención",
  "Título de la notificación",
  "Título de la sesión *",
  "Título del hito *",
  "Título principal",
  "Título principal de Organize",
  "TLS · 465",
  "Todas / sin temática",
  "Todas las cantidades",
  "Todas las jornadas",
  "Todas las salas",
  "todas las temáticas",
  "Todas las temáticas",
  "Todas las unidades temáticas",
  "Todavía no fue vinculada con una sesión del programa.",
  "Todavía no hay grabaciones de esta participación.",
  "Todavía no hay integrantes del faculty asignados.",
  "Todavía no hay personal asociado a este expositor.",
  "Todavía no hay plantillas con canal email disponibles para este evento.",
  "Todavía no hay plantillas publicadas.",
  "Todavía no hay registros.",
  "Todavía no hay stands ubicados en esta planta. Configuralos en “Plantas y stands”.",
  "Todavía no hay transacciones de IA registradas localmente para este evento.",
  "Todavía no se configuró un subdominio personalizado en el evento.",
  "Todo el faculty",
  "Todo lo que pasa detrás de un gran evento.",
  "Todos",
  "Todos los días",
  "Todos los dispositivos instalados",
  "Todos los estados",
  "Todos los roles",
  "Todos los salones",
  "todos los subeventos",
  "Todos los subeventos",
  "Todos los subeventos / proceso general",
  "Todos los tipos de Faculty",
  "Todos los trabajos",
  "Todos los trabajos aprobados ya tienen una mesa.",
  "tokens",
  "Tokens de entrada",
  "Tokens de salida",
  "Tope de crédito en USD",
  "Topic-based assignments, scores, evaluation tracking and communications to authors.",
  "Total",
  "trabajo",
  "Trabajo",
  "Trabajo científico ·",
  "trabajos",
  "Trabajos",
  "Trabajos aprobados sin mesa",
  "Trabajos asignados",
  "Trabajos científicos",
  "Trabajos coincidentes",
  "Trabajos con dictamen final",
  "Trabajos recientes",
  "Tradução simultânea",
  "Tradução simultânea e participação",
  "Traducción al idioma del país del participante",
  "Traducción en preparación",
  "Traducción en vivo",
  "Traducción simultánea",
  "Traducción simultánea por IA",
  "Traducción simultánea y participación",
  "Transacciones",
  "Transacciones realizadas por Meeting Organize",
  "transacciones.",
  "Transcripción del audio",
  "Transcripción original en curso",
  "trash",
  "Tratamiento",
  "Tu agenda todavía está vacía",
  "Tu agenda, incluso sin conexión",
  "Tu correo, en el evento",
  "Tu cuenta está protegida",
  "Tu investigación merece una presentación impecable.",
  "Tudo o que acontece por trás de um grande evento.",
  "Tus derechos y comunicaciones",
  "Ubicación aproximada por stand según la baliza detectada. Los puntos separan visualmente a las personas; no indican su posición exacta dentro del stand. Actualización cada 10 segundos.",
  "Ubicaciones y tamaños",
  "Última hora",
  "Última señal:",
  "Últimas 24 horas",
  "Últimas 4 horas",
  "Últimas visitas registradas",
  "Último aviso:",
  "Últimos 30 días",
  "Últimos 30 minutos",
  "Últimos 7 días",
  "Um espaço de trabalho para coordenar o programa científico, os palestrantes e a operação. Do primeiro convite à última mudança de agenda.",
  "Un correo por dirección, aunque coincidan varias participaciones o trabajos. Se respeta el contacto por asistente configurado.",
  "Un cupo en 0 significa sin límite.",
  "Un espacio de trabajo para coordinar el programa científico, los disertantes y la operación. Desde la primera invitación hasta el último cambio de agenda.",
  "Un hito puede cambiar uno, ambos o ninguno.",
  "Una sesión del programa puede contener una o varias mesas.",
  "Unidad temática",
  "Unidades temáticas de arbitraje",
  "unsubscribe",
  "URL de transmisión",
  "Usá el email registrado. Te enviaremos un código de 4 dígitos al celular declarado.",
  "Usá la configuración general de meetingPlanner o una casilla exclusiva.",
  "Usar código por WhatsApp",
  "Usar esta foto",
  "Use of the website and its content",
  "user",
  "users",
  "Uso del sitio y sus contenidos",
  "Uso do site e de seus conteúdos",
  "Usuario",
  "Usuario activo",
  "Usuario activo y habilitado para iniciar sesión por WhatsApp o contraseña",
  "Usuario eliminado",
  "Usuario SMTP",
  "Usuario y contraseña",
  "usuarios",
  "Usuarios",
  "usuarios · cuentas habilitadas para el evento activo",
  "Usuarios del evento",
  "Usuarios del organizador",
  "Usuarios expositores de Organize",
  "Usuarios y roles",
  "UUID",
  "UUID *",
  "Vagas e inscrições",
  "Validación de participaciones",
  "Validando eventos activos…",
  "Validando vinculación…",
  "Validar e ingresar",
  "Validar participaciones",
  "Vencido",
  "Vencidos",
  "Ver agenda",
  "Ver agenda completa",
  "Ver destinatarios",
  "Ver detalle por fila",
  "Ver eventos",
  "Ver material:",
  "Ver participaciones y presentaciones",
  "Ver presentación",
  "Ver reporte general",
  "Ver trabajo",
  "Ver trabajo original",
  "Ver transcripción original",
  "Verificá que LibreOffice esté instalado en el servidor para visualizar PPT y PPTX.",
  "Verificar API Key efectiva",
  "Versiones del reglamento por idioma oficial",
  "video",
  "Video Meeting",
  "Video Meeting · audio de la sala desde el servidor",
  "video_meeting",
  "Videoconferencias",
  "Vincula este evento con los anteriores de la misma organización y permite reutilizar su Faculty.",
  "Vinculá tu participación con los espacios que visitás mediante localización y balizas, con tu consentimiento y en dispositivos compatibles.",
  "Vincular un número celular",
  "Vincule sua participação aos espaços visitados por localização e Balizas, com seu consentimento e em dispositivos compatíveis.",
  "virtual",
  "VIRTUALMEDICA",
  "virtualMedica · Organize",
  "VirtualMedica | Technology for every stage of your scientific event",
  "VirtualMedica | Tecnología para cada etapa de tu evento científico",
  "VirtualMedica | Tecnologia para cada etapa do seu evento científico",
  "visitas",
  "Vista actual",
  "Vista previa no disponible en el navegador",
  "Visual · tarjetas y accesos en mosaico",
  "Visualización",
  "VM / 01",
  "Volvé al programa completo y agregá las sesiones que te interesan.",
  "Volver a corregir con IA",
  "Voz inmediata activa",
  "waiting",
  "whatsapp",
  "WhatsApp",
  "WhatsApp → Dispositivos vinculados → Vincular dispositivo.",
  "WhatsApp al guardar",
  "WhatsApp con código de país",
  "WhatsApp conectado",
  "WhatsApp de acceso",
  "WhatsApp de prueba",
  "WhatsApp del evento",
  "WhatsApp desenlazado",
  "WhatsApp no está vinculado",
  "WhatsApp, correo, convocatorias y seguimiento.",
  "WhatsApp, e-mail, convites e acompanhamento.",
  "WhatsApp, email, invitations and follow-up.",
  "WhatsApp:",
  "withdrawn",
  "Workshops and activities",
  "X/Y y ancho/alto son porcentajes de la planta.",
  "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
  "y crear nuevos eventos para esta entidad.",
  "Ya cargado",
  "Your agenda, even offline",
  "Your event, always at hand.",
  "Your rights and communications"
] as const;
